"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorDescriptor = void 0;
const CodeDescriptor_1 = require("./CodeDescriptor");
const assignCodeToError_1 = require("./assignCodeToError");
const type_check_1 = require("@pallad/type-check");
const TYPE_CHECK = new type_check_1.TypeCheck('@pallad/errors/ErrorDescriptor');
class ErrorDescriptor extends CodeDescriptor_1.CodeDescriptor {
    constructor(code, factory) {
        super(code);
        this.factory = factory;
        TYPE_CHECK.assign(this);
        Object.freeze(this);
    }
    create(...args) {
        return (0, assignCodeToError_1.assignCodeToError)(this.code, this.factory(...args));
    }
    static useDefaultMessage(code, defaultMessage, errorClass) {
        const finalErrorClass = errorClass !== null && errorClass !== void 0 ? errorClass : Error;
        return new ErrorDescriptor(code, (message) => {
            return new finalErrorClass(message !== null && message !== void 0 ? message : defaultMessage);
        });
    }
    static useMessageFormatter(code, messageFormatter, errorClass) {
        const finalErrorClass = errorClass !== null && errorClass !== void 0 ? errorClass : Error;
        return new ErrorDescriptor(code, (...args) => {
            return new finalErrorClass(messageFormatter(...args));
        });
    }
    withExtraProperties(extraProperties) {
        return new ErrorDescriptor(this.code, (...args) => {
            return Object.assign(this.create(...args), extraProperties);
        });
    }
}
exports.ErrorDescriptor = ErrorDescriptor;
ErrorDescriptor.isType = TYPE_CHECK.isType;
